"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRoutes = void 0;
const AxiosWrapper_1 = require("./AxiosWrapper");
const createRoutes = (baseURL, bearerToken, callback) => {
    const axiosInstance = new AxiosWrapper_1.AxiosWrapper(baseURL, bearerToken).axiosInstance;
    return callback(axiosInstance);
};
exports.createRoutes = createRoutes;
